import React from "react"
import WrapRootElement from "./src/wrap-root-element"
import WrapPageElement from "./src/wrap-page-element"
import createEmotionCache from "./src/utils/create-emotion-cache"
import "./src/styles/global-html-classes.scss"

const clientSideEmotionCache = createEmotionCache()

export const wrapRootElement = ({ element }) => (
  <WrapRootElement element={element} emotionCache={clientSideEmotionCache} />
)

export const shouldUpdateScroll = ({
  routerProps: { location },
  getSavedScrollPosition,
}) => {
  if (location.hash) return false

  window.history.scrollRestoration = "manual"

  const saved = getSavedScrollPosition(location, location.key)
  if (!saved) return false

  const [x, y] = saved
  const restore = () => requestAnimationFrame(() => window.scrollTo(x, y))

  restore()
  setTimeout(restore, 25)                   
  return false                          
}

export const wrapPageElement = ({ element, props }) => (
  <WrapPageElement element={element} props={props} />
)
